import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import CustomBoard from "../../../../components/CustomBoard";
import "fontsource-muli";
import CustomButton from "../../../../components/CustomButton";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../../../common/selectors";
import * as registrationSelector from "../../../../../common/selectors/registration";
import * as registrationAction from "../../../../../common/actions/registration";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import AuthManager from "../../../../../utils/AuthManager";

class MobileVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      mobileNumber: "",
      nric: "",
      localNric:"",
      localClientMobile:"",
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    await AuthManager.retrieveNric().then((value) => {
      if (value) {
       
        this.setState({ localNric: value });
      
      }
    });
    await AuthManager.retrieveClientMobileNo().then((value) => {
      if (value) {
      
        this.setState({ localClientMobile: value });
       
      }
    });
    //const { clientMobileNo, nric } = this.props.location.state;

    //this.setState({ mobileNumber: clientMobileNo });
    //this.setState({ nric: nric });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate() {
   
    const { registrationOTPReqStatus,registrationOTPReqData,registrationOTPReqLoading } = this.props;
    const otpReference = registrationSelector.registrationOtpReference(
      registrationOTPReqData);
   
     if (registrationOTPReqStatus === true && registrationOTPReqData !== null && registrationOTPReqLoading === false ) {
       const { history } = this.props;
       AuthManager.setOtpReference(otpReference);
        AuthManager.setNric(this.state.localNric);
       //history.push("/prototype/RegistrationOtp",{nric:this.state.nric, otpReference});
       history.push("/RegistrationOtp");
       
     }
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onClickSendOTP = () => {
    // const { registrationOTPReqStatus,registrationOTPReqData,registrationOTPReqLoading } = this.props;
    // const otpReference = registrationSelector.registrationOtpReference(
    //   registrationOTPReqData);
    //   AuthManager.setOtpReference(otpReference);
    //   AuthManager.setNric(this.state.localNric);
     const {history} = this.props;
     history.push("/RegistrationOtp")
     //const { registrationOtpRequest } = this.props;
     //registrationOtpRequest(this.state.localNric);
  };

  renderChildren = () => {
    const { classes } = this.props;
    var a = this.state.localClientMobile.substring(this.state.localClientMobile.length - 4);
 
    return (
      <div>
        <CustomText design={classes.headerTextStyle}>
          Mobile Verification
        </CustomText>
        <div style={{ marginTop: 50, marginBottom: 50 }}>
          <CustomText design={classes.mobileTitleTextStyle}>
            Your Mobile Number
          </CustomText>
          <div className={classes.mobileNoContainer}>
            <CustomText design={classes.mobileNoTextStyle}>
              xxxx-{a}
            </CustomText>
          </div>
        </div>
        <CustomButton
          title={"Next"}
          design={classes.buttonStyle}
          onClick={this.onClickSendOTP}
        />
      </div>
    );
  };

  render() {
    const { classes,registrationOTPReqLoading } = this.props;
    const { height } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoard children={this.renderChildren()} height={height} />
        {registrationOTPReqLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
  },
  mobileTitleTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
  },
  mobileNoContainer: {
    width: 140,
    borderRadius: 5,
    backgroundColor: "#eaeef2",
    marginTop: 15,
    marginBottom: 35,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 5,
    paddingBottom: 5,
  },
  mobileNoTextStyle: {
    fontSize: 21,
    ...getFontWeight("bold"),
    color: "#2c3034",
  },
  buttonStyle: {
    width: 120,
  },
});

function mapStateToProps(state) {
  return {
    registrationOTPReqData: selector.registrationOTPReqData(state),
    registrationOTPReqLoading: selector.registrationOTPReqLoading(state),
    registrationOTPReqStatus: selector.registrationOTPReqStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    registrationOtpRequest: (nric) =>
      dispatch(registrationAction.registrationOtpRequest(nric)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(MobileVerification)));
